// import { datadogRum } from '@datadog/browser-rum';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { routes } from './routes/new-routes';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const router = createBrowserRouter(routes);

const App = () => {
    return (
        <>
            <RouterProvider router={router} />
        </>
    );
};

const AppWithLaunchDarkly = withLDProvider({
    clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID,
    options: {
        streaming: true,
        // streamUrl: 'https://core5.andsend.com/lds', Stream URL does not need to be proxied
        baseUrl: 'https://core5.andsend.com/ldb',
        eventsUrl: 'https://core5.andsend.com/lde',
    },
})(App);

export default AppWithLaunchDarkly;
